module.exports = __webpack_public_path__ + "img/icon-pyramid.7d814af5.svg";